window.CarouselAPI = window?.CarouselAPI || {};

// Render image
function renderImage(card) {
  if (!card?.image) {
    return "";
  }
  return `<img src="${card.image}" alt="${card?.title ?? ""}">`;
}

// Render favourite button
function renderFavouriteButton(card) {
  if (!card?.localStorageObject || !card?.title) {
    return "";
  }
  const { getLocalized } = window?.CarouselAPI?.Utils || {};
  const icon = getLocalized("heart_icon");
  if (!icon) {
    return "";
  }
  const dom = `
        <button 
            class="favourite-heart small-heart"
            data-favourite-object='${JSON.stringify(card.localStorageObject)}'
            data-add-button-text="${getLocalized("Lisää suosikiksi")}"
            data-remove-button-text="${getLocalized("Poista suosikeista")}"
            data-add-announcer-message="${getLocalized("Lisätty suosikiksi")}"
            data-remove-announcer-message="${getLocalized("Poistettu suosikeista")}">
            ${icon}
            <span class="sr-only">${card.title || ""}</span>
        </button>
    `;
  const template = document.createElement("template");
  template.innerHTML = dom.trim();
  return template;
}

function renderDescriptions(card) {
  return card?.descriptions && card.descriptions.length
    ? card.descriptions
        .map((desc) => `<p class="carousel-card-description">${desc}</p>`)
        .join("")
    : "";
}

function renderCheckbox(apartmentId) {
  return `<input
          type="checkbox"
          class="fake-input"
          value="${apartmentId}"
          id="carousel-${apartmentId}"
        >`;
}

const IMAGE_WRAPPER = ".carousel-card-image";
const TITLE_WRAPPER = ".carousel-card-title";
const DESCRIPTIONS_WRAPPER = ".carousel-card-descriptions";
const LINK_WRAPPER = ".carousel-link";
const LOCALSTORAGE_WRAPPER = "button[data-favourite-object]";
const TAG_WRAPPER = ".vacancy-label";
const CHECKBOX_INPUT = "input[type='checkbox']";

window.CarouselAPI.Templates = {
  /**
   * Renders a single card based on existing card from DOM
   * Replaces given data to certain classes so no need to duplicate templates between server/client
   * @param {*} card
   * @param {*} cardTemplate
   * @returns
   */
  renderCard(card, cardTemplate) {
    if (!card || !cardTemplate) {
      console.warn("Can not re-filter carousel. Invalid data");
      return;
    }
    // This function uses a copy of DOM element as template and fills in the data
    // If you need to replace Cards or a single card to carousel differently,
    // consider creating a new renderCards method to swiperApi.js and creating a new render single-card render function here.
    const { animationClass } = window?.CarouselAPI?.Utils || {};

    // Make a copy:
    const copy = cardTemplate.cloneNode(true);
    copy.classList.add(animationClass);

    // Render image
    const imageWrapper = copy.querySelector(IMAGE_WRAPPER);
    imageWrapper.innerHTML = renderImage(card);

    // Render title
    const titleWrapper = copy.querySelector(TITLE_WRAPPER);
    titleWrapper.innerHTML = card.title;

    if (titleWrapper.hasAttribute("for") && card?.apartmentId) {
      titleWrapper.setAttribute("for", `carousel-${card.apartmentId}`);
    }

    // Render descriptions
    const descriptions = copy.querySelector(DESCRIPTIONS_WRAPPER);
    descriptions.innerHTML = renderDescriptions(card);

    // Render link
    const linkWrapper = copy.querySelector(LINK_WRAPPER);
    linkWrapper.href = card?.link;

    if (!linkWrapper.children.length) {
      // Has only string as text/title so we can override innerHTML
      // If has children --> DOM ELEMENTS are manipulated throught classes
      linkWrapper.innerHTML = card.title;
    }

    const tagWrapper = copy.querySelector(TAG_WRAPPER);
    tagWrapper.innerHTML = card?.freeDateString;

    // Render localstorage button if exists
    const localStorageButton = copy.querySelector(LOCALSTORAGE_WRAPPER);

    if (localStorageButton) {
      localStorageButton.replaceWith(renderFavouriteButton(card));
    }

    const apartmentId = copy.getAttribute("data-apartmentId");

    if (apartmentId && card?.apartmentId) {
      copy.setAttribute("data-apartmentId", card.apartmentId);
    }

    const checkboxWrapper = copy.querySelector(".gchoice");
    if (checkboxWrapper && card?.apartmentId) {
      checkboxWrapper.innerHTML = renderCheckbox(card.apartmentId);
    }

    return copy.outerHTML;
  },
};
